import { useMediaQuery } from "@mui/material";
import { FC } from "react";
import TopSection from "../../../../components/TopSection";
import { CountersStatsResponse } from "../../../../services/api/admin/stats";
import styles from "./styles.module.scss";

type Props = {
    counters: CountersStatsResponse;
    isLoading: boolean;
};

const HeaderStats: FC<Props> = ({
    counters,
    isLoading,
}) => {
    const isMobile = useMediaQuery("(max-width: 1050px)");

    const formatCurrency = (value: number) =>
        `${new Intl.NumberFormat("fr-FR", {
            maximumFractionDigits: 0,
        }).format(value || 0)} $`;

    const formatPercentage = (value: number) =>
        new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(value ?? 0);

    return (
        <div className={styles.container}>
            <TopSection
                className="stat"
                loading={isLoading}
                title="Total perf."
                value={formatCurrency(counters.totalTrades)}
            />
            <TopSection
                className="stat"
                loading={isLoading}
                title={isMobile ? "Payouts" : "Payouts globaux"}
                value={formatCurrency(counters.totalPayouts)}
            />
            <TopSection
                className="stat"
                loading={isLoading}
                title={isMobile ? "Formation" : "En cours de formation"}
                value={`${counters.activeMembers || 0}`}
            />
            <TopSection
                className="stat"
                loading={isLoading}
                title={isMobile ? "Formés" : "Membres formés"}
                value={`${counters.trainedMembersCount || 0}`}
            />
            <TopSection
                className="stat"
                loading={isLoading}
                title={isMobile ? "Day win" : "Day win moyen"}
                value={`${formatPercentage(counters.averageDayWinPercentage)}%`}
            />
        </div>
    );
};

export default HeaderStats;
